import React from "react";
import { useTranslation } from "react-i18next";
import { Link, generatePath } from "react-router-dom";
import { ROUTES } from "../../utils/Constant";

import styles from "./Project.module.scss";

const Project = (props) => {
  const { t } = useTranslation();
  const { projectId, name } = props;

  return (
    <React.Fragment>
      <div className={styles.container}>
        <Link to={generatePath(ROUTES.DESIGNS, { projectId })} key={projectId}>
          <span>{name ? name : t("project.project")}</span>
        </Link>
      </div>
    </React.Fragment>
  );
};

export default Project;
